import { Button, Form, Input, InputNumber, Modal, Select, Alert } from "antd";

import { selectFormOptionsNoFormatting } from "../../../../../utils/helper";

const CreateEditHintModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title={isEdit ? "Edit Hint" : "Create Hint"}
      centered
      open={isModalOpen}
      footer={null}
      onCancel={() => setIsModalOpen(false)}
    >
      {/* Note Section */}
      <Alert
        type="info"
        showIcon
        message="Note"
        description={
          <>
            Enter unlock time in <b>cumulative manner</b> (always in seconds). Example: • 1st hint →
            30 sec • 2nd hint → 60 sec (i.e. 30 sec after 1st) • 3rd hint → 150 sec • Editorial →
            300 sec
            <br />
            This means each hint unlocks at the given time from the start.
          </>
        }
      />
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_hint_form"
        onFinish={handleCreateEdit}
        layout="vertical"
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[
            {
              required: true,
              message: "Please enter a title!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["Hint 1", "Hint 2", "Hint 3", "Editorial"])}
            showSearch
            allowClear
          />
        </Form.Item>

        <Form.Item
          name="content"
          label="Content"
          rules={[
            {
              required: true,
              message: "Please enter a LaTeX-based hint"
            }
          ]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item
          name="unlockAtSeconds"
          label="Unlock At (seconds)"
          rules={[
            {
              required: true,
              message: "Please enter unlock time in seconds"
            },
            {
              type: "number",
              min: 1,
              message: "Time must be at least 1 second"
            }
          ]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="Enter time in seconds" />
        </Form.Item>

        <Form.Item className="submit-btn" style={{ marginTop: "16px" }}>
          <Button type="primary" htmlType="submit" block>
            {isEdit ? "Update" : "Create"} Hint
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditHintModal;
